export interface SearchResult {
    id: string | number;
    title: string;
    subtitle?: string;
    devSubtitle?: string;
    /** Categoría del resultado de búsqueda */
    category: ESearchCategory | string;
    /** Acción a ejecutar al seleccionar el resultado "Enter" */
    action: () => void;
}

export interface SearchProvider {
    key: string; // "alumno", "docente"
    label: string;
    search: (query: string) => SearchResult[];
}

export enum ESearchCategory {
    RECENT = 'Recientes',
    MODULES = 'Módulos',
    // ENTITIES = 'Entidades',
    OTROS = 'Otros'
}